/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, inject, h } from 'vue';
import Spot from './Spot.js';
import RefLine from './RefLine.js';
import { lineProps } from './props.js';
import useSpotCheck from './hooks/useSpotCheck.js';
import useStyles from './hooks/useStyles.js';
import dataToPoints from './utils/dataToPoints.js';
import uid from './utils/uid.js';
import isEmpty from './utils/isEmpty.js';
import './constant.js';
import './_chunks/dep-680ea5a1.js';
import './utils/min.js';
import './utils/max.js';
import './utils/mean.js';
import './utils/midRange.js';
import './utils/median.js';
import './utils/stdev.js';
import './utils/variance.js';
import './utils/debounce.js';
import './utils/genColor.js';
import './Text.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Line = defineComponent({
  name: "SparklineLine",
  inheritAttrs: false,
  props: lineProps,
  setup: function setup(props2) {
    var eventBus = inject("eventBus");
    var id = uid();

    var _useSpotCheck = useSpotCheck(),
        checkSpotType = _useSpotCheck.checkSpotType;

    var _useStyles = useStyles(props2.styles),
        lineStyle = _useStyles.lineStyle,
        fillStyle = _useStyles.fillStyle;

    return {
      eventBus: eventBus,
      id: id,
      checkSpotType: checkSpotType,
      lineStyle: lineStyle,
      fillStyle: fillStyle
    };
  },
  render: function render() {
    var id = this.id,
        data = this.data,
        hasSpot = this.hasSpot,
        spotProps = this.spotProps,
        spotlight = this.spotlight,
        spotStyles = this.spotStyles,
        limit = this.limit,
        width = this.width,
        height = this.height,
        margin = this.margin,
        max = this.max,
        min = this.min,
        styles = this.styles,
        refLineStyles = this.refLineStyles,
        eventBus = this.eventBus,
        checkSpotType = this.checkSpotType,
        lineStyle = this.lineStyle,
        fillStyle = this.fillStyle;

    if (!data.length) {
      return null;
    }

    var props2 = this.$props;
    var hasSpotlight = typeof spotlight === "number";
    var leeway = 10;
    var points = dataToPoints({
      data: data,
      limit: limit,
      width: width,
      height: height,
      margin: margin,
      max: max,
      min: min,
      textHeight: hasSpotlight ? leeway : 0
    });
    var linePoints = points.map(function (p) {
      return [p.x, p.y];
    }).reduce(function (a, b) {
      return a.concat(b);
    });
    var closePolyPoints = [points[points.length - 1].x, height - margin, margin, height - margin, margin, points[0].y];
    var fillPoints = linePoints.concat(closePolyPoints);
    eventBus.updateValue({
      id: "sparkline__".concat(id),
      color: styles.stroke || styles.fill || "#fff",
      data: data,
      points: points,
      limit: limit,
      type: "line"
    });
    return h("g", function () {
      var items = [];
      items.push(h("polyline", {
        style: fillStyle,
        points: fillPoints.join(" ")
      }), h("polyline", {
        style: lineStyle,
        points: linePoints.join(" ")
      }));
      hasSpotlight && points.map(function (p, key) {
        return checkSpotType({
          props: props2,
          items: items,
          point: p,
          i: key,
          hasSpotlight: hasSpotlight
        }) && items.push(h("circle", {
          style: spotStyles,
          cx: p.x,
          cy: p.y,
          r: spotProps.size,
          rel: data[key],
          key: key
        }));
      });
      hasSpot && items.push(h(Spot, _objectSpread(_objectSpread({}, props2), {}, {
        points: points
      })));
      !isEmpty(refLineStyles) && items.push(h(RefLine, _objectSpread(_objectSpread({}, props2), {}, {
        points: points
      })));
      return items;
    }());
  }
});

export { Line as default };
//# sourceMappingURL=Line.js.map
